import React, { useState, useEffect, useContext } from 'react';
import logo from '../../../assets/images/AI4R_logo.png';
import * as S from '../Interests/Interests.Style';
import '../Interests/Interests.css';
import axios from '../../../hooks/axios';
import { normalizeTag } from '../../../utils/tagUtils';
import updateUserProfile from '../../../hooks/useUpdateUserProfile';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../hooks/UserContext';

export default function Interests() {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const { updateProfile } = updateUserProfile();
  const [userInput, setUserInput] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const handleCheckboxClick = (tag) => {
    setUserInput((prevInput) =>
      prevInput.includes(tag)
        ? prevInput.filter((input) => input !== tag)
        : [...prevInput, tag]
    );
  };

  const ArrayToString = (array) => array.join(',');

  const StringToArray = (string) => {
    if (string) {
      return string.split(',').filter(Boolean);
    }
    return [];
  };
  const handleSubmit = async (e) => {
    let user_interests = ArrayToString(userInput);
    user.user_interests = user_interests;
    await updateProfile(user);
  };
  const handleSkip = async (e) => {
    navigate('/');
  };
  useEffect(() => {
    if (user) {
      const userInterests = StringToArray(user.user_interests)
        .map((tag) => normalizeTag(tag))
        .filter(Boolean);
      setUserInput(userInterests);
    }

    const loadTags = async () => {
      try {
        const year = new Date().getFullYear();
        const response = await axios.get(`archive/?y=${year}&q=topics`);
        const topics = response.data?.topics || [];
        const normalizedTags = topics
          .map((topic) => {
            if (!topic) return null;
            if (typeof topic === 'string') return normalizeTag(topic);
            if (typeof topic === 'object' && topic.value) return normalizeTag(topic.value);
            return null;
          })
          .filter(Boolean)
          .filter((tag) => tag !== 'unknown');
        setAllTags(normalizedTags.map((icon) => ({ icon })));
      } catch (error) {
        console.error('Failed to load topic tags', error);
      }
    };

    loadTags();
  }, [user]);
  return (
    <div>
      <div className="account-brand">
        <S.Brand>
          <S.MenuLink to="#">
            <S.Logo src={logo} alt="AI4Reporters" />
          </S.MenuLink>

          <S.MenuLink to="#">
            <S.Name>AI 4 REPORTERS</S.Name>
          </S.MenuLink>
        </S.Brand>
      </div>
      <div style={{ display: 'flex' }}>
        <S.Conatiner>
          <h2>Choose Interests</h2>
          <S.FilterDiv>
            <S.FilterBoxes>
              {allTags.map(({ icon }, i) => {
                return (
                  <S.MenuItem key={i}>
                    <label
                      className="check-container"
                      style={{ 'text-align': 'left' }}
                    >
                      {icon === 'public_safety'
                        ? 'Public Safety'
                        : icon[0].toUpperCase() + icon.substring(1)}
                      <input
                        name="interest_checkbox[]"
                        type="checkbox"
                        checked={userInput.includes(icon)}
                        onChange={() => {
                          handleCheckboxClick(icon);
                        }}
                        id="option"
                      />
                      <span className="checkmark"></span>
                    </label>
                  </S.MenuItem>
                );
              })}
            </S.FilterBoxes>
            <S.StateTags>
              <S.StateTagsWrap>
                <label
                  className="check-container"
                  style={{ 'text-align': 'left' }}
                >
                  California
                  <input
                    value="California"
                    name="state_checkbox[]"
                    type="checkbox"
                    checked={isChecked2}
                    onChange={(event) =>
                      setIsChecked2(event.currentTarget.checked)
                    }
                  />
                  <span className="checkmark"></span>
                </label>
              </S.StateTagsWrap>
              <S.StateTagsWrap>
                <label
                  className="check-container"
                  style={{ 'text-align': 'left' }}
                >
                  Florida
                  <input
                    value="Florida"
                    name="state_checkbox[]"
                    type="checkbox"
                    onChange={(event) =>
                      setIsChecked(event.currentTarget.checked)
                    }
                    checked={isChecked}
                  />
                  <span className="checkmark"></span>
                </label>
              </S.StateTagsWrap>
            </S.StateTags>
          </S.FilterDiv>
          <button
            onClick={handleSubmit}
            className="filter-button"
            type="button"
          >
            Submit
          </button>
          <button
            type="button"
            className="skip-button"
            onClick={handleSkip}
          >
            Skip For Now
          </button>
        </S.Conatiner>
      </div>
    </div>
  );
}
